import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const UL = ({ boldItems = false, className = '', listItems, listStyle = 'disc' }: Props) => {
  const listStyleClass = listStyle === 'disc' ? 'list-disc pl-6' : 'list-none pl-0';
  const listItemClasses = boldItems ? 'font-bold' : 'font-normal';
  const classNames = `list-outside mt-4 gap-1 ${className}`;

  return (
    <ul className={`${listStyleClass} ${classNames}`}>
      {listItems.map((item, index) => (
        <li key={index} className={`${listItemClasses} mb-3`}>
          {listStyle === 'greenCheckmarks' ? (
            <div className="flex">
              <FontAwesomeIcon
                className="fill-white text-uniform-green-600 text-xl mt-0.5 mr-2"
                icon={faCheckCircle}
              />
              {item}
            </div>
          ) : (
            item
          )}
        </li>
      ))}
    </ul>
  );
};

export default UL;
